import type { FC } from "react";

import { isEditing } from "@builder.io/sdk-react";

import { ReferralStats as UIReferralStats } from "@jti/loyalty/components/ReferralStats";

import type { referralStatsInputs } from "./ReferralStats.builder";

type ReferralStatsBuilderProps = BuilderComponentProps<typeof referralStatsInputs>;

export const ReferralStats: FC<ReferralStatsBuilderProps> = (props) => {
  return <UIReferralStats {...props} isInEditor={isEditing()} />;
};
